import { updateUser } from "@/services/api";
import { useCurrentUser } from "@/services/hooks";
import { Box, Skeleton, TextField, Avatar, Stack } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";
import AlertSnackbar from "@/components/AlertSnackbar";
import { Sms } from "@mui/icons-material";

export default function EditWelcomeSms() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const metaKey = "sms";

  const url = `${window.location.origin}/${currentUser?.key}`;

  const [value, setValue] = useState("");
  const defaultText = `
Hey it's ${currentUser?.name} - welcome to my Notebook! You'll get a message from me when I post a new song, and we'll be able to talk about them in the chat. I'm so excited to share with you!

You can access at anytime at: ${url}

`.trim();

  useEffect(() => {
    if (currentUser) {
      setValue(currentUser.meta?.[metaKey] || defaultText);
    }
  }, [currentUser]);

  const mutation = useMutation({
    mutationFn: () => updateUser(null, { [metaKey]: value }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const debouncedSave = useCallback(
    debounce((newValue) => {
      mutation.mutate();
    }, 1000),
    []
  );

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSave(newValue);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={56}
        width="100%"
        sx={{ borderRadius: "25px" }}
      />
    );
  }

  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />

      <TextField
        label={<Sms />}
        multiline
        value={value}
        fullWidth
        onChange={handleChange}
        disabled={mutation.isPending}
      />
    </Box>
  );
}
